export default "__VITE_ASSET__8cde3828__"